// components/AccessDenied.js
import { faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';

const AccessDenied = () => {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate('/'); // Redirige a la página principal
    };

    return (
        <div className="content pt-3" style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            fontFamily: 'sans-serif',
            backgroundColor: '#f8f9fa', // Light gray background
            color: '#495057', // Darker gray text
            padding: '20px',
            textAlign: 'center',
        }}>
            <FontAwesomeIcon icon={faBan} size="5x" color="#dc3545" style={{ marginBottom: '20px' }} />
            <h2 style={{
                color: '#dc3545',
                marginBottom: '10px',
                fontSize: '2rem',
                fontWeight: '500',
            }}>Acceso Denegado</h2>
            <p style={{
                maxWidth: '500px',
                marginBottom: '20px',
                fontSize: '1.1rem',
                lineHeight: '1.6',
            }}>
                Lo sentimos, no tienes los permisos necesarios para visualizar esta sección.
            </p>
            <p style={{
                maxWidth: '500px',
                marginBottom: '30px',
                fontSize: '1.1rem',
                lineHeight: '1.6',
            }}>
                Si crees que deberías tener acceso, por favor contacta con el administrador del sistema.
            </p>
            <button
                onClick={handleGoBack}
                style={{
                    padding: '12px 24px',
                    backgroundColor: '#215732',
                    color: 'white',
                    border: 'none',
                    borderRadius: '0.25rem',
                    cursor: 'pointer',
                    fontSize: '1.1rem',
                    transition: 'background-color 0.2s ease-in-out',
                    ':hover': {
                        backgroundColor: '#215732',
                    },
                }}
            >
                Volver al Inicio
            </button>
        </div>
    );
};

export default AccessDenied;